<template>
  <v-tooltip bottom z-index="600">
    <template #activator="{on}">
      <v-chip v-on="on" :color="color" :text-color="textColor"> <v-icon class="small mr-1 my-2">fa-hotel</v-icon>{{ text }}</v-chip>
    </template>
    <div>
      <h2>{{ $t("travelService.types.hotel") }} ({{ $t("global.request") }})</h2>
      {{ $t("travelService.roomType") }}: {{ roomTypeText }}<br />
      {{ $t("travelService.place") }}: {{ placeText }}<br />
      {{ $t("travelService.accommodationDate") }}: {{ travelServiceOrderItem.hotel.start_date }} {{ travelServiceOrderItem.hotel.start_time }}<br />
      {{ $t("travelService.outDate") }}: {{ travelServiceOrderItem.hotel.end_date }}<br />
      {{ $t("global.breakfast") }} <v-icon small v-if="travelServiceOrderItem.hotel.is_breakfast === 1" color="success">fa-check</v-icon>
      <v-icon small v-else color="error">fa-times</v-icon> <br />
      {{ $t("travelService.isParkingRequired") }} <v-icon small v-if="travelServiceOrderItem.hotel.parking_required === 1" color="success">fa-check</v-icon>
      <v-icon small v-else color="error">fa-times</v-icon> <br />
      {{ $t("travelService.isFreeCancellationRequired") }}
      <v-icon small v-if="travelServiceOrderItem.hotel.is_free_cancellation === 1" color="success">fa-check</v-icon>
      <v-icon small v-else color="error">fa-times</v-icon> <br />
    </div>
    <travel-service-order-item-common-tooltip-part :travel-service-order-item="travelServiceOrderItem" />
  </v-tooltip>
</template>

<script>
import { allRoomTypes } from "../../../staticData/TravelServiceTypes";

import TravelServiceOrderItemCommonTooltipPart from "./TravelServiceOrderItemCommonTooltipPart";
export default {
  name: "TravelServiceOrderItemHotelChip",
  components: { TravelServiceOrderItemCommonTooltipPart },
  props: {
    travelServiceOrderItem: { required: true, type: Object },
    color: { required: false, type: String, default: "" },
    textColor: { required: false, type: String, default: "" },
    text: { required: false, type: String, default: "Usługa hotelowa" }
  },
  data: () => ({
    placeText: ""
  }),
  watch: {
    "travelServiceOrderItem.hotel.place_id"() {
      this.downloadPlace();
    }
  },
  computed: {
    roomTypeText() {
      if (typeof this.travelServiceOrderItem.hotel.room_type !== "undefined") {
        return allRoomTypes().find(v => v.value === this.travelServiceOrderItem.hotel.room_type).text;
      }
      return "";
    }
  },
  methods: {
    downloadPlace() {
      if (this.travelServiceOrderItem.hotel.place_id !== null) {
        this.$store.dispatch("Location/getLocation", { placeId: this.travelServiceOrderItem.hotel.place_id }).then(result => {
          this.placeText = result.text;
        });
      }
    }
  },
  created() {
    this.downloadPlace();
  }
};
</script>

<style scoped></style>
